import { UNIT_CONFIG_BUTTON } from './unit-config.button';
import { Plugin } from '@jeppesen-foreflight/jmkw-types';

export const UNIT_CONFIG_PLUGIN = new Plugin({
  id: 'unit-config',
  button: UNIT_CONFIG_BUTTON
});
